export const audit = {
  description:
    "Who did what, when. The request ID links each event to the matching server log line.",
  filterByAction: "Filter by action",
  filter: {
    allActions: "All actions",
  },
  caption: "Audit events",
  emptyTitle: "No matching events",
  emptyDescription: "Try the full history again or clear the filter.",
  column: {
    action: "Action",
    record: "Record",
    actor: "Actor",
    requestId: "Request ID",
  },
  system: "system",
  action: {
    signIn: "Sign-in",
    signInFailed: "Failed sign-in",
    signOut: "Sign-out",
    userCreated: "User created",
    roleChanged: "Role changed",
    userActivated: "User activated",
    userDeactivated: "User deactivated",
    documentUploaded: "Document uploaded",
    documentDownloaded: "Document downloaded",
    documentDeleted: "Document deleted",
  },
};
